<template>
  <transition name="fade">
    <div class="modal modal-default">
      <div class="modal__overlay" @click="$emit('close')"></div>
      <div class="small-modal">
        <div class="small-modal__close" @click="$emit('close')">X</div>
        <div class="small-modal__head">
          <span>Attention !</span>
        </div>
        <div class="small-modal__body">
          <div class="small-modal__body__block">
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input font-14">
                En raison d’une maintenance informatique, votre espace
                partenaire sera momentanément indisponible ce jeudi 3 avril de
                13h00 à 17h00. Nos bureaux seront également indisponibles durant
                cette période. Nous nous excusons sincèrement pour les
                désagréments occasionnés et vous remercions par avance pour
                votre compréhension.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
  
    <script>
export default {
  name: "WelcomeModal",
  mixins: [],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
<style scoped>
.font-14{
    font-size: 14px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/WelcomeModal.vue